import { render } from "./Screenshots.vue?vue&type=template&id=f9c51760"
import script from "./Screenshots.vue?vue&type=script&lang=js"
export * from "./Screenshots.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__